module.exports = __webpack_public_path__ + "static/img/cycleAI-25.d1a4323.svg";